module.exports = __webpack_public_path__ + "media/images/icons/twotone/sound-0feae5586927c05d348f62eb6ae93a8b.svg";